import React, { memo, useCallback, useEffect, useState } from "react";
import * as XLSX from "xlsx";

import { Image } from "../../components/image";
import { TableFilterInputText } from "../../components/table-filter-inputs";
import { Button, CreateAlert, Icon, ITableStructureItem } from "../../modules";
import { TableSimplePagination } from "../../modules/table/TableSimplePagination";
import { CategoryService } from "../../services/category";
import "./index.scss";
import { ConfirmDeletePopup } from "../../components/confirm-delete-popup";
import ImportButton from "../../components/import-button";

const SongCategoryList = () => {
  const [filterParams, setFilterParams] = useState<any>({
    page: 1,
    pageSize: 10,
  });
  const [dataList, setDataList] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [activeDelete, setActiveDelete] = useState<{ open: boolean, data: any }>({
    open: false,
    data: undefined,
  });



  const handleExportExcel = async () => {
    return new Promise(async (resolve) => {
      try {
        const response = await CategoryService.getList({
          ...filterParams,
          page: 1,
          pageSize: 1000000,
        });

        const data = response.data;

        const fileHead = structure.map((v) => v.name);
        const dataExport = [
          fileHead,
          ...data.map((item: any) =>
            structure.map((column, index) => {
              if (!column.key) return "";
              return item[column.key];
            })
          ),
        ];

        const ws = XLSX.utils.aoa_to_sheet(dataExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "SheetJS");

        const now = new Date();
        XLSX.writeFile(
          wb,
          `Danh sach the loai ${now
            .toLocaleDateString()
            .replace(/\//g, "-")} ${now
            .toLocaleTimeString()
            .replace(/:/g, "-")}.xlsx`,
          { type: "binary" }
        );

        resolve(
          CreateAlert({
            type: "success",
            message: "Xuất dữ liệu thành công",
          })
        );
      } catch (error: any) {
        resolve(CreateAlert({ type: "danger", message: error.message }));
      }
    });
  };

  const handleImport = async (form: FormData ,cb: any) => {
   try {
    const res: any = await CategoryService.import(form)

    if (res?.success) {
      const _params = { page: 1, pageSize: 10 }
      setFilterParams({..._params})
      cb()
      CreateAlert({
        type: "success",
        message: "Nhập dữ liệu thành công",
      })
    }

   } catch (error: any) {
      cb()
      CreateAlert({
        type: "danger",
        message: error.message || 'Xóa dữ liệu thất bại',
      })
   }
  }

  const handleDelete = async () => {
    if (!activeDelete?.data) return

    try {
      const res = await CategoryService.delete(activeDelete?.data?.genreId)

      if (res?.success) {
        setActiveDelete({ open: false, data: undefined })
        const _params = { page: 1, pageSize: 10 }
        setFilterParams({..._params})
        CreateAlert({
          type: "success",
          message: "Xóa dữ liệu thành công",
        })
      }
    } catch (error: any) {
      setActiveDelete({ open: false, data: undefined })
      CreateAlert({
        type: "danger",
        message: error.message || 'Xóa dữ liệu thất bại',
      })
    }
  }
  
  const fetchData = useCallback(async () => {
    setLoading(true);
    const data = await CategoryService.getList(filterParams);
    setDataList(data);
    setLoading(false);
  }, [filterParams]);

    // Table Data
  const structure: ITableStructureItem[] = [
    {
      name: "STT",
      key: "idx",
    },
    {
      name: "ID",
      key: "genreId",
    },
    {
      name: "Hình ảnh",
      key: "fileName",
      render: (item) => {
        return (
          <Image
            src={item?.fileName || "/assets/images/category/category-logo.png"}
            style={{ maxWidth: 120, height: "auto" }}
          />
        );
      },
    },
    {
      name: "Tên thể loại",
      key: "name",
    },
    {
      name: "Thao tác",
      render: (item) => {
        return (
          <div className="btnGroup">
            <span
              className="btn btn__edit"
              onClick={() =>
                setActiveDelete({
                  open: true,
                  data: item,
                })
              }
            >
              <Icon.Delete />
            </span>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="category-list">
      <div className="title">Quản lý thể loại</div>

      <div className="content-wrapper">
        <div className="d-flex mb20" style={{ gap: 20 }}>
          <ImportButton fileUrl="/templates/Template_import-genre.xlsx" onImport={handleImport}/>

          <Button
            label="Xuất excel"
            buttonType="success"
            onClick={handleExportExcel}
          />
        </div>

        <TableSimplePagination
          dataTable={{
            dataList: dataList,
            filterParams: filterParams,
            totalPage: dataList
              ? Math.ceil(dataList?.count / filterParams?.pageSize)
              : 0,
            loading,
          }}
          setParams={setFilterParams}
          filters={[
            {
              name: "Tìm kiếm theo ID, tên thể loại",
              key: "searchString",
              input: (s: any) => {
                return (
                  <TableFilterInputText
                    {...s}
                    params={{
                      ...s.params,
                      searchString: filterParams?.searchString,
                    }}
                  />
                );
              },
            },
            {
              name: "Làm mới",
              key: "searchString",
              input: () => (
                <Button
                  label="Xác nhận"
                  buttonType="info"
                  onClick={() => setFilterParams({ page: 1, pageSize: 10 })}
                />
              ),
            },
          ]}
          structure={structure}
        />
      </div>

      {activeDelete?.open && (
        <ConfirmDeletePopup
          onClose={() => setActiveDelete({ open: false, data: undefined })}
          onConfirm={handleDelete}
        />
      )}
    </div>
  );
};

export default memo(SongCategoryList);
